<div class="main-background">
  <div class="row img-main-container-row">
    <div class="col-10 offset-1 px-sm-1 px-md-2 px-lg-5 img-container-column">
      <div class="row">
        <div class="img-container-row px-0">
          <img
            class="puppy"
            src="/assets/images/home/puppy_no_background.png"
            alt="kitten"
          />
          <img
            class="kitten"
            src="/assets/images/home/kitten_no_background.png"
            alt="puppy"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 mb-2">
      <h2 class="mt-5 mb-0 steps-title">
        Microchipping your pet is the first <br> step to keeping your pet safe - now let’s connect your pet <br> to you
      </h2>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-sm-8 col-md-6 col-lg-8 offset-lg-2 offset-sm-2 offset-md-3">
      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-4 d-flex p-3">

        <!--Card Step1-->
        <div class="col position-relative my-4 pb-lg-5 pb-sm-1 pb-md-1 text-center">
          <img class="paw-icon-upper" src="/assets/images/home/paw.svg" alt="paw" />
          <app-step-card
            title="Step 1"
            [completed]="false"
            subtitle="Connect your pet’s microchip to your details"
            body=""
            [highlighted]="true"
            buttonLabel="Get started now"
            buttonUri="/login-register"
          ></app-step-card>
        </div>

        <!--Card Step2-->
        <div class="col position-relative my-4 pt-lg-5 pt-sm-1 pt-md-1 text-center">
          <img class="paw-icon-lower" src="/assets/images/home/paw.svg" alt="paw" />
          <app-step-card
            title="Step 2"
            [completed]="false"
            subtitle="Add lost & found cover for less than 10p a day"
            body=""
            [highlighted]="false"
            buttonLabel="About our cover"
            buttonUri="/choose-plan"
          ></app-step-card>
        </div>

        <!--Card Step3-->
        <div class="col position-relative my-4 pb-lg-5 pb-sm-1 pb-md-1 text-center">
          <img class="paw-icon-upper" src="/assets/images/home/paw.svg" alt="paw" />
          <app-step-card
            title="Step 3"
            [completed]="false"
            subtitle="Download our app and relax"
            body="You’ve now got protection in your pocket"
            [highlighted]="false"
          ></app-step-card>
        </div>
      </div>
    </div>
  </div>
</div>
